// extracted by mini-css-extract-plugin
module.exports = {"header":"TrainingSection_header__1glw0","title":"TrainingSection_title__QDu70","filters":"TrainingSection_filters__2NOCS","filter":"TrainingSection_filter__2xy8k"};